// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Liberia */
const LR =
  /^(?:(?:(?:(?:22|33)0|555|7(?:6[01]|7\d)|88\d)\d|4(?:240|[67]))\d{5}|[56]\d{6})$/;

export default LR;
